import * as firebaseClient from '@/services/notifications/firebase';
import api from '@/services/api';
import ls from '@/helpers/localStorage';
// import constants from '@/constants';

export const DEFAULT_ORDER_BOOK = {
  noOrders: 0,
  yesOrders: 0,
};

function makeTradeOptions() {
  return {
    contractId: null,
    operationType: 'buy', // buy | sell
    operationValue: 'yes', // yes | no
    pricePerShare: null,
    skipConfirmation: false,
    quantity: null,
  };
}

function getPricePerShare(value) {
  const min = 1;
  const max = 99;
  let price = parseInt(value, 10);

  if (price < min) {
    price = min;
  }
  if (price > max) {
    price = max;
  }
  return price;
}


const KEY_BOTTOM_WIDGET_FOOTER_MODE = 'bottom-widget-footer-mode';
export const BOTTOM_WIDGET_FOOTER_MODES = {
  BETSLIP: 'betslip',
  PINNED: 'pinned',
  TOGGlE: 'toggle',
  QUICK_SWITCH: 'quick-switch',
};
const BOTTOM_WIDGET_DEFAULT_MODE = BOTTOM_WIDGET_FOOTER_MODES.BETSLIP;
const BOTTOM_WIDGET_KEYS_TO_STORE_IN_LS = [
  BOTTOM_WIDGET_FOOTER_MODES.BETSLIP,
  BOTTOM_WIDGET_FOOTER_MODES.PINNED,
  BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH,
];

export default {
  namespaced: true,
  state: {
    orderBook: null,
    hidePurchaseForContractId: null,
    contractShares: [],
    contractOffers: [],
    tradeOptions: makeTradeOptions(),
    masterTradeOptions: {},
    tradeSuccess: false,
    keyboardDoubleSelected: false,
    cancelToggle: false,
    tradeOperationToggle: null,
    isInConfirmationMode: false,
    confirmationDoneData: null,
    confirmationData: null,
    bottomBetslipExtended: false,
    bottomWidgetFooterMode: BOTTOM_WIDGET_DEFAULT_MODE,
    bottomWidgetFooterModeContractsSection: BOTTOM_WIDGET_DEFAULT_MODE,
    previousBottomWidgetFooterMode: BOTTOM_WIDGET_DEFAULT_MODE,
    // ls not used atm
    // bottomWidgetFooterMode: ls.get(KEY_BOTTOM_WIDGET_FOOTER_MODE, BOTTOM_WIDGET_DEFAULT_MODE),
    // previousBottomWidgetFooterMode: ls.get(
    //   KEY_BOTTOM_WIDGET_FOOTER_MODE, BOTTOM_WIDGET_DEFAULT_MODE),
  },
  mutations: {
    toggleHidePurchaseForContractId(state, contractId) {
      if (state.hidePurchaseForContractId === null) {
        state.hidePurchaseForContractId = contractId;
      } else {
        state.hidePurchaseForContractId = null;
      }
    },
    setOrderBook(state, payload) {
      state.orderBook = payload;
    },
    clearOrderBook(state) {
      state.orderBook = null;
    },
    setContractShares(state, payload) {
      state.contractShares = payload;
    },
    setContractOffers(state, payload) {
      state.contractOffers = payload;
    },
    setTradeOptions(state, payload) {
      if (
        state.tradeOptions !== null &&
        payload !== null &&
        state.tradeOptions.contractId === payload.contractId &&
        state.tradeOptions.operationType === payload.operationType &&
        state.tradeOptions.operationValue === payload.operationValue
      ) {
        state.tradeOptions = {
          ...state.tradeOptions,
          ...payload,
        };
      } else {
        const defaults = makeTradeOptions();
        let pricePerShare = defaults.pricePerShare;
        let skipConfirmation = defaults.skipConfirmation;
        if (payload && state.tradeOptions.contractId === payload.contractId) {
          pricePerShare = state.tradeOptions.pricePerShare;
          skipConfirmation = state.tradeOptions.skipConfirmation || false;
        }
        state.tradeOptions = {
          ...defaults,
          ...payload,
          pricePerShare,
          skipConfirmation,
        };
      }

      if (
        state.tradeOptions &&
        state.tradeOptions.contractId
      ) {
        state.hidePurchaseForContractId = null;
      }
    },
    setTradeSuccess(state, flag) {
      state.tradeSuccess = flag;
    },
    setTradeSkipConfirmation(state, skipConfirmation) {
      const value = !!skipConfirmation;
      // const expiresAt = 31536000; // 1 year
      // ls.set('skipConfirmation', value, expiresAt);
      state.tradeOptions = { ...state.tradeOptions, skipConfirmation: value };
    },
    updateKeyboardDoubleSelected(state, selected) {
      state.keyboardDoubleSelected = selected;
    },
    setCancelToggle(state, flag) {
      state.cancelToggle = flag;
    },
    setIsInConfirmationMode(state, flag) {
      state.isInConfirmationMode = flag;
    },
    setConfirmationData(state, data) {
      state.confirmationData = data;
    },
    setConfirmationDoneData(state, data) {
      state.confirmationDoneData = data;
    },
    toggleTradeOperation(state, side) {
      state.tradeOperationToggle = side;
    },
    setBottomWidgetFooterMode(state, value) {
      if (BOTTOM_WIDGET_KEYS_TO_STORE_IN_LS.includes(value)) {
        ls.set(KEY_BOTTOM_WIDGET_FOOTER_MODE, value);
      }
      state.previousBottomWidgetFooterMode = state.bottomWidgetFooterMode;
      state.bottomWidgetFooterMode = value;
    },
    toggleBottomBetslipMode(state) {
      state.bottomBetslipExtended = !state.bottomBetslipExtended;
    },
    setBottomWidgetFooterModeContractsSection(state, value) {
      state.bottomWidgetFooterModeContractsSection = value;
    },
    setTradeQuantity(state, quantity) {
      state.tradeOptions = { ...state.tradeOptions, quantity: parseInt(quantity, 10) || null };
    },
    setTradePrice(state, pricePerShare) {
      state.tradeOptions = { ...state.tradeOptions, pricePerShare };
    },
    setMasterTradeOptions(state, data) {
      state.masterTradeOptions = data;
    },
    setBottomBetSlipExtendedMode(state, extended) {
      state.bottomBetslipExtended = extended;
    },
  },
  actions: {
    confirmTrade({ commit }, payload) {
      return api.trade.postConfirmTrade(payload);
    },
    submitTrade({ commit }, payload) {
      return api.trade.postSubmitTrade(payload);
    },
    getOrderBook({ commit }, contractId) {
      return api.trade.getOrderBook(contractId)
        .then((response) => {
          commit('setOrderBook', response.data);
          return response.data;
        });
    },
    updateOrderBookPeriodically({ commit }, contractId) {
      firebaseClient.addOrderBookListener(contractId, (data) => {
        commit('setOrderBook', data);
      }, Object.create(DEFAULT_ORDER_BOOK));
    },
    clearOrderBookUpdates({ commit }, contractId) {
      firebaseClient.clearOrderBookListeners(contractId);
    },
    clearOrderBook({ commit }) {
      commit('clearOrderBook');
    },
    getContractShares({ commit }, contractId) {
      if (contractId === null) {
        commit('setContractShares', []);
        return Promise.resolve([]);
      }

      return api.profile.getContractShares(contractId)
        .then((response) => {
          commit('setContractShares', response.data.shares);
          return response.data.shares;
        });
    },
    getContractOffers({ commit }, contractId) {
      if (contractId === null) {
        commit('setContractOffers', []);
        return Promise.resolve([]);
      }

      return api.profile.getContractOffers(contractId)
        .then((response) => {
          commit('setContractOffers', response.data.offers);
          return response.data.offers;
        });
    },
    cancelAllOffers({ commit }, payload) {
      const contractId = payload.contractId;
      delete payload.contractId;
      return api.trade.postCancelAllOffers(contractId, payload)
        .then((response) => {
          commit('setCancelToggle', true);
          return response.data;
        });
    },
    cancelOffer({ commit }, offerId) {
      return api.trade.postCancelOffer(offerId)
        .then((response) => {
          commit('setCancelToggle', true);
          return response.data;
        });
    },
    setCancelToggle({ commit }, flag) {
      commit('setCancelToggle', flag);
    },
    setIsInConfirmationMode({ commit }, flag) {
      commit('setIsInConfirmationMode', flag);
    },
    setConfirmationData({ commit }, data) {
      commit('setConfirmationData', data);
    },
    setConfirmationDoneData({ commit }, data) {
      commit('setConfirmationDoneData', data);
    },
    setTradeOptions({ commit }, payload) {
      if (payload === null) {
        commit('setConfirmationData', null);
        commit('setConfirmationDoneData', null);
      }
      commit('setTradeOptions', payload);
    },
    setTradeQuantity({ commit, state }, quantity) {
      commit('setTradeQuantity', quantity);
      commit('setMasterTradeOptions', {
        quantity,
        pricePerShare: state.tradeOptions.pricePerShare,
      });
    },
    setTradePrice({ commit, state }, pricePerShare) {
      const standardValue = getPricePerShare(pricePerShare);
      commit('setMasterTradeOptions', {
        pricePerShare: standardValue,
        quantity: state.tradeOptions.quantity,
      });
      commit('setTradePrice', standardValue);
    },
    setMasterTradeOptions({ commit }, { quantity, pricePerShare }) {
      commit('setMasterTradeOptions', { quantity, pricePerShare });
    },
    setTradeSuccess({ commit }, flag) {
      commit('setTradeSuccess', flag);
    },
    setTradeSkipConfirmation({ commit }, skipConfirmation) {
      commit('setTradeSkipConfirmation', skipConfirmation);
    },
    toggleTradeOperation({ commit }, side) {
      commit('toggleTradeOperation', side);
    },
    updateKeyboardDoubleSelected({ commit }, selected) {
      commit('updateKeyboardDoubleSelected', selected);
    },
    getOrderBookTradeInfo({ commit }, { contractId, tradeType, price }) {
      return api.trade.getOrderBookTradeInfo(contractId, tradeType, price)
        .then(response => response.data);
    },
    setBottomWidgetFooterMode({ commit }, value) {
      commit('setBottomWidgetFooterMode', value);
    },
    toggleHidePurchaseForContractId({ commit }, contractId) {
      commit('toggleHidePurchaseForContractId', contractId);
    },
    toggleBottomBetslipMode({ commit }) {
      commit('toggleBottomBetslipMode');
    },
    setBottomBetSlipExtendedMode({ commit }, value) {
      commit('setBottomBetSlipExtendedMode', value);
    },
    setBottomWidgetFooterModeContractsSection({ commit }, value) {
      commit('setBottomWidgetFooterModeContractsSection', value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/trade.js